<template>
  <div class="module-blog home-module-space" v-if="list.length">
    <div class="container">
      <div v-if="data.title" class="module-blog__title home-title">
        <h5 class="title_font">{{ data.title }}</h5>
      </div>
      <el-row :gutter="30" type="flex" :style="{ flexWrap: 'wrap' }">
        <el-col
          class="module-blog__col"
          :span="24 / columns"
          :xs="24"
          v-for="item in list"
          :key="item.id"
        >
          <v-blog-card :data="item" :col-type="columns" />
        </el-col>
      </el-row>

      <div v-if="button.text && button.url" class="module-blog__button-wrapper">
        <a
          :href="button.url"
          class="module-blog__button home-btn"
          :style="{
            color: buttonStyle.color,
            backgroundColor: buttonStyle.backgroundColor,
          }"
        >
          {{ button.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import BlogCard from "@/js/components/Blog/Card.vue";

export default {
  name: "Blog",
  components: {
    [BlogCard.name]: BlogCard,
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      list: this.data?.blogs || [],
      // 按钮
      button: {
        text: this.data?.button?.text || null,
        url: this.data?.button?.url || null,
      },
      // 列数
      columns: this.data?.columns || 3,
      // 按钮样式
      buttonStyle: {
        backgroundColor: this.data?.button_background_color,
        color: this.data?.button_text_color,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.module-blog {
  margin-bottom: 100px;
  &__title {
    font-size: 42px;
    font-weight: bold;
    margin-bottom: 60px;
    text-align: center;
  }
  &__col {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  &__button-wrapper {
    margin-top: 10px;
    text-align: center;
  }

  &__button {
    display: inline-block;
    padding: 16px 22px;
    line-height: 1;
    font-size: 16px;
    font-weight: 500;
  }

  @media only screen and (max-width: 767px) {
    margin-bottom: 40px;
    &__col {
      padding-top: 10px;
      padding-bottom: 10px;
    }
    &__button-wrapper {
      margin-top: 17px;
      text-align: center;
    }
    &__button {
      padding: 10px 30px;
    }
  }
}
</style>
